import React from 'react';
import $ from 'jquery';
import styled from 'styled-components';

import Attendee from './Attendee';
import { groupByKey } from '../../../helpers';
import female from '../../../svg/female.svg';
import male from '../../../svg/male.svg';
import shared from '../../../svg/shared.svg';
import starSpot from '../../../svg/star-spot.svg';

const Title = styled.div`
  font-family: BrandonGrotesque-Bold;
  font-size: 18px;
  text-align: center;
  font-style: italic;
  color: var(--color-gunmetal);
  padding-top: 10px;
`;

const Subtitle = styled.div`
  font-family: BrandonGrotesque-Regular;
  font-size: 16px;
  text-align: center;
  font-weight: bold;
  color: var(--color-cool-grey);
  padding-bottom: 15px;
`;

const TypeContainer = styled.div`
  margin: 12px auto;
  display: table;
  font-family: BrandonGrotesque-Medium;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.13;
  color: #333333;
`;

const TypeIcon = styled.img`
  margin-right: 5px;
  margin-top: -4px;
`;

const TypeInfo = styled.div`
  margin-right: 20px;
  display: inline;
`;

const AttendeeTypes = ({
  items,
  title,
  offerId = '',
  pluralize = false,
}: {
  items: Attendee[];
  title: string;
  offerId: string;
  pluralize?: boolean;
}) =>
  items ? (
    <>
      <Subtitle>
        {items.length} {title}
        {pluralize && items && items.length > 1 ? 's' : ''}
      </Subtitle>
      <div>
        {items.map((item) => (
          <Attendee attendee={item} offerId={offerId} checkInReady={item.status === 'active'} />
        ))}
      </div>
    </>
  ) : null;

class AttendeeList extends React.Component<
  { close: Function; attendees: Array<Attendee>; offer: Offer },
  {}
> {

  componentDidMount() {
    $('#attendeeList').modal('show');
    $('#attendeeList').on('hidden.bs.modal', (e) => this.props.close());
  }

  render() {
    let attendees = this.props.attendees;

    if (this.props.offer.type === 'gift') {

      attendees = this.props.attendees
        .filter((item) => item.status !== 'canceled')
        .map((item) => {
          return { ...item, status: item.shipment.status };
        });
    }

    const data = groupByKey<Attendee>(attendees, 'status');
    const { offer } = this.props;

    return (
      <div className="modal fade" id="attendeeList" role="dialog">
        <div className="modal-dialog modal-dialog-attendees" style={{ width: '400px' }}>
          <div className="modal-content modal-body-attendees">
            <div style={{ paddingTop: '10px' }}>
              <button
                className="close float-left"
                style={{ marginLeft: '20px', position: 'absolute' }}
                data-dismiss="modal"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <Title>{this.props.attendees.length} CLAIMS</Title>
              <TypeContainer>
                {offer.spots.shared_spots.available ? (
                  <>
                    <TypeIcon height={20} src={shared} />
                    <TypeInfo>
                      {offer.spots.shared_spots.taken}/
                      {offer.spots.shared_spots.available === -1
                        ? '∞'
                        : offer.spots.shared_spots.available}
                    </TypeInfo>
                  </>
                ) : null}
                {offer.spots.female_spots.available ? (
                  <>
                    <TypeIcon height={20} src={female} />
                    <TypeInfo>
                      {offer.spots.female_spots.taken}/
                      {offer.spots.female_spots.available === -1
                        ? '∞'
                        : offer.spots.female_spots.available}
                    </TypeInfo>
                  </>
                ) : null}
                {offer.spots.male_spots.available ? (
                  <>
                    <TypeIcon height={20} src={male} />
                    <TypeInfo>
                      {offer.spots.male_spots.taken}/
                      {offer.spots.male_spots.available === -1
                        ? '∞'
                        : offer.spots.male_spots.available}
                    </TypeInfo>
                  </>
                ) : null}
                {offer.star_spots ? (
                  <>
                    <TypeIcon height={20} src={starSpot} />
                    <TypeInfo>
                      {offer.attendees.filter((a) => a.spot_type === 'star').length}/
                      {offer.star_spots}
                    </TypeInfo>
                  </>
                ) : null}
              </TypeContainer>
              <AttendeeTypes offerId={offer.id} items={data.unknown} title="N/A" />
              <AttendeeTypes offerId={offer.id} items={data.preparing} title="Preparing" />
              <AttendeeTypes offerId={offer.id} items={data.shipped} title="In Transit" />
              <AttendeeTypes offerId={offer.id} items={data.delivered} title="Delivered" />
              <AttendeeTypes offerId={offer.id} items={data.failure} title="Failure" />
              <AttendeeTypes offerId={offer.id} items={data.cancelled} title="Cancelled" />
              <AttendeeTypes
                offerId={offer.id}
                items={data.awaiting_post}
                title="Awaiting Post"
                pluralize
              />
              <AttendeeTypes offerId={offer.id} items={data.active} title="Waiting to check in" />
              <AttendeeTypes offerId={offer.id} items={data.used} title="Checked in" />
              <AttendeeTypes offerId={offer.id} items={data.expired} title="Failed to check in" />
              <AttendeeTypes
                offerId={offer.id}
                items={data.canceled}
                title="Canceled Claim"
                pluralize
              />
              <AttendeeTypes
                offerId={offer.id}
                items={data.incomplete}
                title={
                  offer.type === 'reservation_required' ? 'Awaiting Reservation' : 'Awaiting Post'
                }
                pluralize
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AttendeeList;

export { AttendeeTypes, Subtitle, Title };
